import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import withAnalyticsEvents from '../hocs/withAnalyticsEvents';
import AnalyticsContext from './AnalyticsContext/LegacyAnalyticsContext';
// eslint-disable-next-line @repo/internal/react/no-class-components
export var BaseAnalyticsErrorBoundary = /*#__PURE__*/function (_Component) {
  _inherits(BaseAnalyticsErrorBoundary, _Component);

  var _super = _createSuper(BaseAnalyticsErrorBoundary);

  function BaseAnalyticsErrorBoundary(props) {
    var _this;

    _classCallCheck(this, BaseAnalyticsErrorBoundary);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "fireAnalytics", function (analyticsErrorPayload) {
      var _this$props = _this.props,
          createAnalyticsEvent = _this$props.createAnalyticsEvent,
          channel = _this$props.channel,
          data = _this$props.data;
      createAnalyticsEvent({
        action: 'UnhandledError',
        eventType: 'ui',
        attributes: _objectSpread(_objectSpread({
          browserInfo: window && window.navigator && window.navigator.userAgent ? window.navigator.userAgent : 'unknown'
        }, data), analyticsErrorPayload)
      }).fire(channel);
    });

    _this.state = {
      hasError: false
    };
    return _this;
  }

  _createClass(BaseAnalyticsErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error, info) {
      var onError = this.props.onError;
      var payload = {
        error: error,
        info: info
      };
      this.fireAnalytics(payload);
      onError && onError(error, info);
      this.setState({
        hasError: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          data = _this$props2.data,
          children = _this$props2.children,
          ErrorComponent = _this$props2.ErrorComponent;
      var hasError = this.state.hasError;

      if (hasError && ErrorComponent) {
        return /*#__PURE__*/React.createElement(AnalyticsContext, {
          data: data
        }, /*#__PURE__*/React.createElement(ErrorComponent, null));
      }

      return /*#__PURE__*/React.createElement(AnalyticsContext, {
        data: data
      }, children);
    }
  }]);

  return BaseAnalyticsErrorBoundary;
}(Component);
var AnalyticsErrorBoundary = withAnalyticsEvents()(BaseAnalyticsErrorBoundary);
export default AnalyticsErrorBoundary;